import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaHistoricoAlteracoes } from "./components/TabelaHistoricoAlteracoes"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Histórico de Alterações" />
            <TabelaHistoricoAlteracoes />
        </>
    )
}
